// extracted by mini-css-extract-plugin
export default {"advertDetailTop":"c-e_eC","advertDetailTop__header":"c-e_eE"};